import {getRequest} from './request'
export const initMenu = (router,store) =>{
    if(store.getters.roles[0] !=='Aadmin' && store.getters.roles[0] !== 'Auser'){
        return;
    }
    if(store.state.routes.length>0){
        return;
    }
    // let fmtRoutes = formatRoutes(menus)
    // //  添加到路由
    // router.addRoutes(fmtRoutes)
    // // 将数据存入vueX
    // store.commit('initRoutes',fmtRoutes);
    // console.log('我的commit',fmtRoutes);
    getRequest("/member/member/currentUser").then(data=>{
        if(data.menus){
            // 格式化了的fmtRoutes
            let fmtRoutes = formatRoutes(data.menus)
            //  添加到路由
            // console.log('添加后',fmtRoutes[0].children);
            router.addRoutes(fmtRoutes)
            // 将数据存入vueX
            store.commit('initRoutes',fmtRoutes[0].children);
        }
    })
}
export const formatRoutes = (routes) =>{
    let fmtRoutes = [];
    routes.forEach(router => {
        let{
            id,
            path,
            component,
            name,
            icon,
            children,
        } = router;
        if(children && children instanceof Array){
            //  递归
            children = formatRoutes(children)
        }
        let fmRouter = {
            id:id,
            path:path,
            name:name,
            icon:icon,
            children:children,
            component(resolve){
                if(component.startsWith('aIndex')){
                    require(['../views/adaptation/'+component+'.vue'],resolve);
                }else if(component.startsWith('per')){
                    require(['../views/adaptation/'+component+'.vue'],resolve);
                }else if(component.startsWith('pub')){
                    require(['../views/adaptation/'+component+'.vue'],resolve);
                }else if(component.startsWith('sub')){
                    require(['../views/adaptation/'+component+'.vue'],resolve);
                }
                // else if(component.startsWith('Test')){
                //     require(['../views/NotFound.vue'],resolve);
                // }
            }
        }
        fmtRoutes.push(fmRouter)
    });
    return fmtRoutes;
}